define.alias("shared/components/shared/social-identity/item", "settings/components/shared/social-identity/item");